var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompanyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15.5,
    r: 15,
    fill: "#E9E9E9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9998 12.5833V10.25H9.1665V20.75H20.8332V12.5833H14.9998ZM11.4998 19.5833H10.3332V18.4167H11.4998V19.5833ZM11.4998 17.25H10.3332V16.0833H11.4998V17.25ZM11.4998 14.9167H10.3332V13.75H11.4998V14.9167ZM11.4998 12.5833H10.3332V11.4167H11.4998V12.5833ZM13.8332 19.5833H12.6665V18.4167H13.8332V19.5833ZM13.8332 17.25H12.6665V16.0833H13.8332V17.25ZM13.8332 14.9167H12.6665V13.75H13.8332V14.9167ZM13.8332 12.5833H12.6665V11.4167H13.8332V12.5833ZM19.6665 19.5833H14.9998V18.4167H16.1665V17.25H14.9998V16.0833H16.1665V14.9167H14.9998V13.75H19.6665V19.5833ZM18.4998 14.9167H17.3332V16.0833H18.4998V14.9167ZM18.4998 17.25H17.3332V18.4167H18.4998V17.25Z",
    fill: "#B7B7B7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyIcon);
export default __webpack_public_path__ + "static/media/company-icon.5a45abdcf825c1d7790d0b427f5c5af1.svg";
export { ForwardRef as ReactComponent };